import React from 'react';

export const cookieHeaders = [
    {
        title: 'Types of cookie and similar technologies',
        dataIndex: 'type',
        key: 'type',
        render: data => <span><b>{ data }</b></span>,
        width: '240px',
    },
    {
        title: 'Name(s) used by this site',
        dataIndex: 'names',
        key: 'names',
        render: data => data.map( ( name, index ) => ( <div key={ `name-${ index }` }><small>{ name }</small></div> ) ),
        width: '180px',
    },
    {
        title: 'Purpose',
        dataIndex: 'purpose',
        key: 'purpose',
        render: data => <small>{ data }</small>,
    },
    {
        title: 'Data stored within the cookie',
        dataIndex: 'cookieData',
        key: 'cookieData',
        render: data => <ul className="cookie-table-data-list">{
            data.map( ( d, index ) => <li key={ `data-${ index }` }><small>{ d }</small></li> )
        }</ul>,
        width: '180px',
    },
];

export const cookieTables = [
    {
        title: 'Essential Cookies',
        data: [
            {
                type: 'JavaScript Cookie',
                names: [ 'chameleonID' ],
                purpose: 'The purpose of placing this cookie is to set up a unique course ID number for use in the LMS portal and is not used to track any user data.',
                cookieData: [ 'Course ID Number' ],
            },
        ],
    }
];
